<template>
  <VModal>
    <VBlock class="wrapper" slot="contents" :direction="Direction.column">
      <VSpan class="title" text="결제 정보" :size="16" :weight="TextWeight.bold" />
    </VBlock>
    <VBlock slot="footer" class="button-wrapper">
      <VButton class="cancel-button" :color="ButtonColor.brand" :onClick="onOK">
        <VSpan text="확인" :size="14" :color="TextColor.white" />
      </VButton>
    </VBlock>
  </VModal>
</template>

<script>
import VButton, { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'
import VSpan, { TextColor, TextWeight, TextType } from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VHR from '@/presentationals/v2/components/layouts/atoms/VHR'

import VBlock, { Sort, Direction } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VModal from '@/presentationals/v2/components/layouts/molecules/VModal'

export default {
  name: 'ModalPaymentDetail',
  props: {
    title: {
      type: String,
      required: true
    },
    onOK: {
      type: Function,
      required: true
    },
    params: {
      type: Object,
      required: true
    }
  },
  components: {
    VButton,
    VSpan,
    VHR,

    VBlock,
    VModal
  },
  data() {
    return {
      ButtonColor,
      TextColor,
      TextWeight,
      TextType,
      Direction,
      Sort
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.wrapper {
  padding: 0 12px 0 12px;

  .title {
    margin-bottom: 16px;
  }

  .discount-header {
    margin-bottom: 8px;
  }

  .discount {
    margin-bottom: 4px;
  }

  .underline {
    margin-top: 8px;
    margin-bottom: 8px;
  }
}

.button-wrapper {
  border-top: 1px solid $light-gray-2;
  height: 50px;
  background-color: $brand;

  .cancel-button,
  .ok-button {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .mid-line {
    width: 2px;
    height: 100%;
    background-color: $light-gray-2;
  }
}
</style>
